<ion-card [ngClass]="isGuestUser ? '' : 'not-guest'">
  <section
    [ngClass]="{
      'image-section-with-promotions':
        hasPromotionDetails && showPromotionDetailInTablet,
      'image-section-with-promotions-not-show-in-tablet':
        hasPromotionDetails && !showPromotionDetailInTablet,
      'image-section-without-promotions': !hasPromotionDetails,
    }"
    (click)="onProductImageClick()"
    data-cy="click-navigate-to-pdp-page"
  >
    <section
      #mainImage
      *ngIf="
        !!product?.orderedImages &&
        !!product?.orderedImages[0]?.urls[ImageVariantEnum.Small]
      "
    >
      <img
        src="{{ product?.orderedImages[0]?.urls[ImageVariantEnum.Small] }}"
        [attr.data-cy]="
          'image' + product?.orderedImages[0]?.urls[ImageVariantEnum.Small]
        "
        #mainImage
      />
    </section>
    <section class="image-viewer" *ngIf="!product?.orderedImages?.length">
      <ion-icon
        name="restaurant"
        class="no-image"
        data-cy="no-image-product-detail-icon"
      ></ion-icon>
    </section>
  </section>
  <ion-card-header>
    <ion-card-subtitle
      [attr.data-cy]="
        'product-brand' + product?.summary?.productNumber + 'text'
      "
      >{{
        (product?.summary?.brand?.length > 15
          ? (product?.summary?.brand | slice: 0 : 12) + '...'
          : product?.summary?.brand) || productBrandNotAvailableMessage
          | translate
          | titlecase
      }}
    </ion-card-subtitle>
    <ion-card-title
      (click)="navigateToProductPage()"
      [attr.data-cy]="
        'product-description' + product?.summary?.productNumber + 'text'
      "
    >
      {{
        product?.summary?.productDescTxtl ||
          productDescriptionNotAvailableMessage
          | translate
          | titlecase
      }}
    </ion-card-title>
    <ion-card-subtitle>
      <span
        class="basic-information swiper-no-swiping"
        [attr.data-cy]="
          'product-number' + product?.summary?.productNumber + 'text'
        "
      >
        #{{ product?.summary?.productNumber }}
        <span class="divider">|</span>
        {{ product?.summary?.salesPackSize | lowercase }}
      </span>
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content *ngIf="!isGuestUser">
    <div
      (click)="clickPromotions($event)"
      data-cy="click-promotions-item"
      [ngClass]="
        showPromotionDetailInTablet
          ? 'card-promotion-detail'
          : 'not-show-promotion-detail-tablet'
      "
      *ngIf="product?.promotionDetails?.offerBenefitDesc"
    >
      <span
        class="card-promotion-detail-text"
        [attr.data-cy]="'promotion' + product?.summary?.productNumber + 'text'"
      >
        {{ product?.promotionDetails.offerBenefitDesc }}</span
      >
    </div>
    <div class="product-quantities-section">
      <div class="left-quantity-section">
        <app-quantity-input
          [productNumber]="product?.summary?.productNumber"
          [isDisabled]="isDisable"
          [isEaches]="false"
          [platform]="platformService.platformType"
          [quantity]="(orderItem$ | async)?.unitsOrdered"
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
        ></app-quantity-input>

        <span
          *ngIf="product?.pricing?.unitPrice * 1 > 0"
          class="price-text"
          [attr.data-cy]="'price' + product?.summary?.productNumber + 'text'"
          >{{ (product?.pricing?.unitPrice | currency) || 'loading...' }}
          {{ product?.pricing?.unitPrice ? product?.summary.priceUom : '' }}
        </span>
        <span
          *ngIf="product?.pricing?.unitPrice * 1 === 0"
          class="price-text"
          data-cy="no-price-text"
          >{{ 'i18n.lists.noPrice' | translate }}
        </span>
      </div>
      <div *ngIf="product?.summary?.breakable" class="right-quantity-section">
        <app-quantity-input
          [productNumber]="product?.summary?.productNumber"
          [isDisabled]="isDisable"
          [isEaches]="true"
          [platform]="platformService.platformType"
          [quantity]="(orderItem$ | async)?.eachesOrdered"
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
        ></app-quantity-input>
        <span
          *ngIf="product?.pricing?.eachPrice * 1 > 0"
          class="price-text"
          [attr.data-cy]="
            'product-each-price' + product?.summary?.productNumber + 'text'
          "
          >{{
            (product?.pricing?.eachPrice | currency) ||
              'i18n.productDetail.loading' | translate
          }}
          {{
            product?.pricing?.eachPrice
              ? product?.summary?.catchWeightFlag
                ? '/' + product?.summary?.priceUom
                : product?.summary?.eachUom
              : ''
          }}
        </span>
        <span
          *ngIf="product?.pricing?.eachPrice * 1 === 0"
          class="price-text"
          data-cy="no-each-price-text"
          >{{ 'i18n.lists.noPrice' | translate }}
        </span>
      </div>
    </div>
    <div></div>
  </ion-card-content>
</ion-card>
